import materialUI from './material-ui'
import css from './css'

export default function initPlugins(): Promise<void> {
  return Promise.all([materialUI(), css()]).then((results: string[]) => {
    return Promise.resolve()
  })
}
